import { DocumentDetailsPanel } from '~/components/Shared/DocumentDetailsPanel/DocumentDetailsPanel';
import { usePanelContext } from '~/eds/src/components/Panel/PanelContext';

import { getDocumentHandlerId } from '../helpers/getResourceUrl';
import { EnrichedGroupNode } from '../helpers/NodeEnricher/NodeEnricher';
import { TreeBrowserNode } from '../helpers/TreeBrowser/types';
import { TicketDetailPanel } from './TicketDetailPanel';

export interface NodeDetailPanelProps {
  node: TreeBrowserNode<EnrichedGroupNode> | null;
  onClose: () => void;
  currentGroup?: string;
}

export const NodeDetailPanelId = 'node-detail';

export const NodeDetailPanel = ({
  node,
  onClose,
  currentGroup,
}: NodeDetailPanelProps) => {
  const { openPanelId } = usePanelContext();

  if (!node || openPanelId !== NodeDetailPanelId) {
    return null;
  }

  if (node.attributes.resourceType === 'document') {
    const docHandlerId = getDocumentHandlerId(node);

    return (
      <DocumentDetailsPanel
        key={docHandlerId}
        docHandlerId={parseInt(docHandlerId)}
        currentGroupId={currentGroup}
        onHide={onClose}
      />
    );
  }

  return (
    <TicketDetailPanel
      ticket={node}
      onClose={onClose}
      currentGroup={currentGroup}
    />
  );
};
